var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import muiGrey from '@material-ui/core/colors/grey';
export var primary = {
    contrastText: '#fff',
    dark: '#7C4672',
    light: '#fff5fd',
    main: '#8E5082',
};
export var secondary = {
    contrastText: '#fff',
    dark: '#00af9e',
    light: '#e6f7f5',
    main: '#00c5ba',
};
export var positive = {
    contrastText: '#fff',
    dark: '#3e9c01',
    light: '#f3fbed',
    main: '#48b600',
};
export var negative = {
    contrastText: '#fff',
    dark: '#cb302c',
    light: '#fff8f8',
    main: '#e94944',
};
export var warning = {
    contrastText: '#fff',
    dark: '#f4b208',
    light: '#fffcf4',
    main: '#ffc21b',
};
export var orange = {
    contrastText: '#fff',
    dark: '#e66300',
    light: '#fffaf7',
    main: '#fa7009',
};
export var white = {
    contrastText: '#000',
    dark: '#fff',
    light: '#fff',
    main: '#fff',
};
export var grey = __assign(__assign({}, muiGrey), { 50: '#f9f9f9', 100: '#f3f4f5', 200: '#e8ebed', 300: '#d4d9dd', 400: '#aab4bb', 500: '#808f9a', 600: '#566a79', 700: '#2d4658', 800: '#1B2D3A' });
//# sourceMappingURL=colors.js.map